module.exports = __webpack_public_path__ + "static/media/17-8.0b3facc4.mp3";